/*
 * This page will be displayed on the Audi Nemo site inside an iframe
 */

import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import Button from '../audi-ui-components/Button';
import { renderCourseDates } from '../lib/helpers';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import {
    PATH_COURSE,
    FEATURE_TOGGLE,
    DEFAULT_THEME,
} from '../constants';

class NemoLocationsPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetchingData: false,
            venues: [],
            hostname: ""
        }
    }

    componentDidMount() {
        let q = queryString.parse(this.props.location.search);
        let theme = q.theme || DEFAULT_THEME;
        if (theme === "dark") {
            document.body.classList.add("theme-dark");
        }
        this.setState({isFetchingData: true, hostname: window.location.protocol + "//" + window.location.hostname});
        fetch(
            `${process.env.RAZZLE_ADE_API}/1/venues`,
            {method: 'GET', headers: {Accept: 'application/json', 'Cache-Control': 'no-cache'}}
        ).then((response) => {
            if (response.status >= 400) {
                let error = new Error(response.statusText);
                error.response = response;
                error.status = response.status;
                throw error;
            }
            return response.json();
        }).then((venueData) => {
            var filteredVenues = [];
            var len = venueData.length;
            for (let i=0; i<len; i++) {
                let venue = venueData[i];
                if (!venue.isPrivate) {
                    venue.programs = [];
                    fetch(
                        `${process.env.RAZZLE_ADE_API}/1/venues/${venue.id}/programs`,
                        {method: 'GET', headers: {Accept: 'application/json', 'Cache-Control': 'no-cache'}}
                    ).then((response) => {
                        return response.json();
                    }).then((programList) => {
                        if (programList.length > 0) {
                            var pLen = programList.length;
                            for (let p=0; p<pLen; p++) {
                                let program = programList[p];
                                if (!program.isPrivate) {
                                    let dates = [];
                                    let eLen = program.experiences.length;
                                    for (let e=0; e<eLen; e++) {
                                        if (!program.experiences[e].isPrivate) {
                                            dates.push(moment(program.experiences[e].startDate));
                                        }
                                    }
                                    if (dates.length > 1) {
                                        dates = dates.sort((a, b) => a.format('YYYYMMDD') - b.format('YYYYMMDD'));
                                    }
                                    if (dates.length > 0) {
                                        program.dates = dates;
                                        venue.programs.push(program);
                                    }
                                }
                            }
                            if (venue.programs.length > 0) {
                                filteredVenues.push(venue);
                                this.setState({venues: filteredVenues});
                            }
                        }
                    });

                }
            }
            this.setState({isFetchingData: false});
        }).catch((error) => {
            console.log(error);
            //
        });
    }

    render() {
        let q = queryString.parse(this.props.location.search);
        let theme = q.theme || DEFAULT_THEME;
        const {venues, isFetchingData, hostname} = this.state;
        const isLoaded = !isFetchingData && venues.length > 0;
        const sortedVenues = venues.sort((a, b) => {
            let aDate = a.programs && a.programs.length && a.programs[0].dates && a.programs[0].dates.length ? a.programs[0].dates[0].format('YYYYMMDD') : 0;
            let bDate = b.programs && b.programs.length && b.programs[0].dates && b.programs[0].dates.length ? b.programs[0].dates[0].format('YYYYMMDD') : 0;
            return aDate - bDate;
        });
        return (
            <div className={cn("iframe-content iframe-table", {"theme-dark": theme === "dark", "theme-light": theme === "light"})}>
            <div className="iframe-content__inner">

                {(FEATURE_TOGGLE.MAINTENANCE || FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE) && <div className="maintenance-note">
                    {!FEATURE_TOGGLE.MAINTENANCE && FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE && <div dangerouslySetInnerHTML={{__html: FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE}}></div>}
                    {FEATURE_TOGGLE.MAINTENANCE && FEATURE_TOGGLE.MAINTENANCE_NOTE && <div dangerouslySetInnerHTML={{__html: FEATURE_TOGGLE.MAINTENANCE_NOTE}}></div>}
                </div>}

                <div className="aui-table aui-table--stretched">
                    <Helmet>
                        <script>{`
                            var savedHeight = 0;
                            function sendHeight() {
                                var appHeight = document.getElementById('AppContainer').offsetHeight + 50;
                                if(appHeight !== savedHeight) {
                                    savedHeight = appHeight;
                                    var pxHeight = appHeight + "px";
                                    var payload = { height : pxHeight, url: window.location.href };
                                    window.parent.postMessage(JSON.stringify(payload), '*');
                                }
                            }
                            if (window && window.parent) {
                                window.setInterval(sendHeight, 1000);
                            }
                        `}</script>
                    </Helmet>
                    <table>
                        <thead>
                            <tr>
                                <th>Track</th>
                                <th>Experience</th>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        {isLoaded && sortedVenues.map((venue) => {
                            if (venue.programs.length > 0) {
                                return (
                                    <tbody key={`venue_${venue.id}`}>
                                        {venue.programs.map((program, i) => <tr key={`program_${program.id}`}>
                                            {i === 0 && <td rowSpan={venue.programs.length}>{venue.location}</td>}
                                            <td>{program.name}</td>
                                            <td>{renderCourseDates(program.dates)}</td>
                                            <td style={{textAlign: 'center'}}>
                                                <Button variant="primary" theme={theme === "dark" ? "light" : null} className="red" href={`${hostname}/${PATH_COURSE}/${program.slug}/${venue.slug}`} target="_blank" disabled={FEATURE_TOGGLE.MAINTENANCE}>Book now</Button>
                                            </td>
                                        </tr>)}
                                    </tbody>
                                );
                            }
                            return null;
                        })}
                    </table>
                </div>
            </div>
            </div>
        );
    }
}

export default NemoLocationsPage;
